import { render, staticRenderFns } from "./kyc-risk-evaluation-tree.vue?vue&type=template&id=119e21d8"
import script from "./kyc-risk-evaluation-tree.vue?vue&type=script&lang=js"
export * from "./kyc-risk-evaluation-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports